<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-02 09:46:14
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 16:21:26
 * @FilePath: \nivara\src\views\wallet\components\bindBankView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="bindbank-container" v-loading="userBankListLoading">
    <div class="bindbank-banklist-box">
      <div
        class="bindbank-bankitem"
        v-for="item in userBindBankListData"
        :key="item.bank_id"
      >
        <div
          class="bindbank-info"
          @click="useCurrentBindBankToWithdraw(item.bank_id)"
        >
          <div class="info-bank-icon">
            <el-image
              :src="
                require('../../../assets/images/banklogo/' +
                  item.bank_logo +
                  '@2x.png')
              "
            />
          </div>
          <div class="info-bank-name-number">
            <div class="info-bank-name">{{ item.bank_name }}</div>
            <div class="info-bank-number">{{ item.bank_account }}</div>
          </div>
        </div>
        <div class="bindbank-opreation">
          <div class="bindbank-default" @click="setUserDefaultBindBank(item)">
            <el-image
              :src="
                item.is_def === 1
                  ? require('../../../assets/images/agreement_register_phone_active.png')
                  : require('../../../assets/images/agreement_register_phone.png')
              "
            />Default bank card
          </div>
          <div class="bindbank-delete">
            <el-popconfirm
              confirm-button-text="Yes"
              cancel-button-text="No, Thanks"
              cancel-button-type="info"
              title="Are you sure to delete this bank card?"
              @confirm="confirmEvent(item.bank_id)"
              @cancel="cancelEvent"
            >
              <template #reference>
                <el-image
                  :src="require('../../../assets/images/close_popup.png')"
                />
              </template>
            </el-popconfirm>
          </div>
        </div>
      </div>
      <div class="bindbank-bankitem add" @click="openAddBindBank">
        <el-image :src="require('../../../assets/images/add_bank_icon.png')" />
        Add bank card
      </div>
    </div>
    <Popup
      title="add new bank card"
      ref="addBindbankRef"
      @closePopup="closePopup"
    >
      <template #content>
        <el-form
          class="add-bindban-form"
          :model="addBindbankFormData"
          label-position="top"
          v-loading="getBankNameLoading"
          element-loading-text="Get bank card name please wait..."
        >
          <el-form-item label="Bank Category">
            <el-select v-model="addBindbankFormData.bank_category_id">
              <el-option
                v-for="item in bankCategoryListData"
                :key="item.bank_category_id"
                :label="item.bank_name"
                :value="item.bank_category_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Bank Account Number">
            <el-input
              v-model="addBindbankFormData.bank_account"
              @blur="getBankName"
            />
          </el-form-item>
          <el-form-item label="Bank Account Name">
            <el-input v-model="addBindbankFormData.user_name" />
          </el-form-item>
          <el-button @click="addBindBank">Submit</el-button>
        </el-form>
      </template>
    </Popup>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import { ElNotification } from "element-plus";
import {
  getUserBankListApi,
  addUserBindBankApi,
  deleteUserBindBankApi,
  setUserDefaultBindBankApi,
  getBankCategoryListApi,
  getBankNameApi,
} from "../../../api/index";
import Popup from "../../../components/popupView.vue";
import { InfoFilled } from "@element-plus/icons-vue";
import bus from "../../../utils/eventBus";

export default defineComponent({
  name: "Wallet",
  components: { Popup },
  setup() {
    onMounted(() => {
      getUserBankList();
      getBankCategoryList();
    });
    const walletType = ref(0);
    const addBindbankRef = ref(null);
    const getBankNameLoading = ref(null);
    const state = reactive({
      userBindBankListData: [],
      bankCategoryListData: [],
      addBindbankFormData: {
        bank_category_id: "",
        bank_account: "",
        user_name: "",
      },
    });
    // 打开添加绑定银行弹框
    const openAddBindBank = () => {
      addBindbankRef.value.open();
    };
    // 添加绑定银行
    const addBindBank = () => {
      addUserBindBank();
    };
    // 关闭弹框
    const closePopup = () => {
      state.addBindbankFormData.bank_category_id = "";
      state.addBindbankFormData.bank_account = "";
      state.addBindbankFormData.user_name = "";
    };
    // 删除银行卡
    const confirmEvent = (bankId) => {
      deleteUserBindBank(bankId);
    };
    // 取消删除银行卡
    const cancelEvent = () => {};

    // 设置默认银行卡
    const setUserDefaultBindBank = (bankObj) => {
      if (bankObj.is_def == 1) {
        return;
      } else {
        setUserDefaultBindBankApi({
          token: localStorage.getItem("token"),
          bank_id: bankObj.bank_id,
        }).then((res) => {
          if (res.data.success) {
            ElNotification({
              title: "Tips",
              message: "Setting Success",
              type: "success",
            });
            nextTick(() => {
              getUserBankList();
            });
          }
        });
      }
    };
    // 使用当前选中银行卡去提现
    const useCurrentBindBankToWithdraw = (bankId) => {
      bus.emit("useCurrentBindBankToWithdraw", bankId);
    };
    // 删除银行卡
    const deleteUserBindBank = (bankId) => {
      deleteUserBindBankApi({
        token: localStorage.getItem("token"),
        bank_id: bankId,
      }).then((res) => {
        if (res.data.success) {
          ElNotification({
            title: "Tips",
            message: "Delete Success",
            type: "success",
          });
          nextTick(() => {
            getUserBankList();
          });
        }
      });
    };
    // 根据银行和银行号码获取银行名字
    const getBankName = () => {
      // 有银行类型 和银行卡号
      if (
        state.addBindbankFormData.bank_category_id &&
        state.addBindbankFormData.bank_account
      ) {
        getBankNameLoading.value = true;
        let data = {
          token: localStorage.getItem("token"),
          bank_category_id: state.addBindbankFormData.bank_category_id,
          bank_account: state.addBindbankFormData.bank_account,
        };
        getBankNameApi(data)
          .then((res) => {
            console.log(res);
            if (res.data.success) {
              if (res.data.data.user_name) {
                state.addBindbankFormData.user_name = res.data.data.user_name;
              } else {
                ElNotification({
                  title: "Tips",
                  message:
                    "not find the corresponding information, please enter it manually",
                  type: "error",
                });
              }
            }
            getBankNameLoading.value = false;
          })
          .catch(() => {
            ElNotification({
              title: "Tips",
              message: "get corresponding information err",
              type: "error",
            });
            getBankNameLoading.value = false;
          });
      }
    };
    // 添加绑定银行卡
    const addUserBindBank = () => {
      if (state.addBindbankFormData.bank_category_id) {
        if (state.addBindbankFormData.bank_account) {
          if (state.addBindbankFormData.user_name) {
            let data = {
              token: localStorage.getItem("token"),
              bank_category_id: state.addBindbankFormData.bank_category_id,
              bank_account: state.addBindbankFormData.bank_account,
              user_name: state.addBindbankFormData.user_name,
            };
            addUserBindBankApi(data).then((res) => {
              console.log("addUserBindBankApi", res);
              if (res.data.success) {
                if (res.data.data.bank_id) {
                  ElNotification({
                    title: "Tips",
                    message: "Add Bank Card Success",
                    type: "success",
                  });
                  addBindbankRef.value.close();
                  nextTick(() => {
                    state.addBindbankFormData.bank_category_id = "";
                    state.addBindbankFormData.bank_account = "";
                    state.addBindbankFormData.user_name = "";
                    getUserBankList();
                  });
                }
              } else {
                ElNotification({
                  title: "Tips",
                  message: res.data.msg,
                  type: "error",
                });
                addBindbankRef.value.close();
                getUserBankList();
              }
            });
          } else {
            ElNotification({
              title: "Tips",
              message: "Please enter Bank Account Name",
              type: "error",
            });
          }
        } else {
          ElNotification({
            title: "Tips",
            message: "Please enter Bank Account Number",
            type: "error",
          });
        }
      } else {
        ElNotification({
          title: "Tips",
          message: "Please select Bank Category",
          type: "error",
        });
      }
    };
    // 获取银行卡种类列表数据
    const getBankCategoryList = () => {
      getBankCategoryListApi({
        token: localStorage.getItem("token"),
        country_id: localStorage.getItem("country_id"),
      }).then((res) => {
        console.log("getBankCategoryListApi", res);
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.bankCategoryListData = res.data.data;
          } else {
            state.bankCategoryListData = [];
          }
        }
      });
    };
    const userBankListLoading = ref(false);
    // 获取用户银行卡列表数据
    const getUserBankList = () => {
      userBankListLoading.value = true;
      getUserBankListApi({ token: localStorage.getItem("token") }).then(
        (res) => {
          console.log("getUserBankListApi：", res);
          if (res.data.success) {
            if (res.data.data.length > 0) {
              state.userBindBankListData = res.data.data;
            } else {
              state.userBindBankListData = [];
            }
            userBankListLoading.value = false;
          } else {
            userBankListLoading.value = false;
            ElNotification({
              title: "Tips",
              message: res.data.msg,
              type: "error",
            });
          }
        }
      );
    };
    return {
      InfoFilled,
      walletType,
      addBindbankRef,
      getBankNameLoading,
      openAddBindBank,
      getBankName,
      addBindBank,
      closePopup,
      confirmEvent,
      cancelEvent,
      setUserDefaultBindBank,
      useCurrentBindBankToWithdraw,
      userBankListLoading,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.bindbank-container {
  .bindbank-banklist-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .bindbank-bankitem {
      width: 30%;
      height: 147px;
      min-height: 147px;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      padding: 20px;
      margin: 10px 0;
      border: 1px solid #e3e3e3;
      border-radius: 12px;
      box-sizing: border-box;
      &.add {
        justify-content: center;
        align-items: center;
        background-color: #e3e3e3;
        cursor: pointer;
        .el-image {
          width: 30px;
          height: 30px;
          margin-bottom: 10px;
        }
      }
      .bindbank-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        cursor: pointer;
        .info-bank-icon {
          width: 56px;
          height: 56px;
          border: 1px solid #eeeeee;
          border-radius: 50%;
          .el-image {
            width: 56px;
            height: 56px;
          }
        }
        .info-bank-name-number {
          flex: 1;
          margin-left: 10px;
          color: #03034d;
          text-align: left;
          .info-bank-name {
            margin: 5px 0;
            font-size: 16px;
            font-weight: bold;
          }
          .info-bank-number {
            margin: 5px 0;
            font-size: 14px;
          }
        }
      }
      .bindbank-opreation {
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #e3e3e3;
        .bindbank-default {
          display: flex;
          align-items: center;
          cursor: pointer;
          .el-image {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
        .bindbank-delete {
          display: flex;
          width: 10px;
          height: 10px;
          cursor: pointer;
          .el-image {
            width: 10px;
            height: 10px;
          }
        }
      }
      &:nth-child(3n + 2) {
        margin: 10px 5%;
      }
    }
  }
  .add-bindban-form {
    padding: 20px;
    .el-select {
      width: 100%;
    }
    :deep(.el-form-item) {
      margin-bottom: 10px;
    }
    :deep(.el-form-item__label) {
      padding: 0;
      font-weight: bold;
      color: #000000;
    }
    :deep(.el-input__inner) {
      border-radius: 12px;
    }
    .el-button {
      margin-top: 20px;
      background-color: #03034d;
      border-radius: 12px;
      color: #ffffff;
    }
  }
}
</style>
